import CustomCursor from "@/components/CustomCursor";
import Loader from "@/components/Loader";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Marquee from "@/components/Marquee";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Brands from "@/components/sections/Brands";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import Pricing from "@/components/sections/Pricing";
import Faq from "@/components/sections/Faq";
import Contact from "@/components/sections/Contact";

const MARQUEE = [
  "We Come To You", "Full Synthetic", "20 Minute Service", "5.0 Rated",
  "No Waiting Rooms", "Fleet Welcome", "Lethbridge, AB", "Fully Mobile",
];

export default function Landing() {
  return (
    <>
      <CustomCursor />
      <Loader />
      <Navbar />
      <main>
        <Hero />
        <div className="border-y border-ink-soft bg-ink-surface py-6">
          <Marquee items={MARQUEE} />
        </div>
        <About />
        <Services />
        <Brands />
        <Process />
        <Testimonials />
        <Pricing />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
